type PathOptions = {
  trimStart?: boolean;
  trimEnd?: boolean;
  separator?: string;
};

export const formatPathFromSegments = (
  segments: string[],
  options: PathOptions = {},
): string => {
  const { trimStart = false, trimEnd = false, separator = " / " } = options;

  const trimmed = [...segments];

  if (trimStart) trimmed.shift();
  if (trimEnd) trimmed.pop();

  return trimmed.join(separator);
};
